<template>
    <div class="multi-select-dropdown" :class="{ 'is-open': isOpen }">
        <button
            type="button"
            class="multi-select-trigger"
            @click="toggleDropdown"
            :aria-label="ariaLabel"
        >
            <span class="multi-select-label">{{ displayLabel }}</span>
            <svg class="multi-select-arrow" :class="{ 'rotated': isOpen }" width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>

        <div v-if="isOpen" class="multi-select-dropdown-panel">
            <div class="multi-select-options">
                <label v-for="option in options" :key="option.id" class="multi-select-option">
                    <input
                        type="checkbox"
                        :value="option.id"
                        :checked="selectedValues.includes(option.id)"
                        @change="handleOptionToggle(option.id)"
                        class="multi-select-checkbox"
                    />
                    <span class="multi-select-option-text">{{ option.name }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MultiSelectDropdown',
    props: {
        options: {
            type: Array,
            required: true,
        },
        selectedValues: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            required: true,
        },
        ariaLabel: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        displayLabel() {
            if (this.selectedValues.length === 0) {
                return this.placeholder;
            } else if (this.selectedValues.length === 1) {
                const option = this.options.find((opt) => opt.id === this.selectedValues[0]);
                return option ? option.name : this.placeholder;
            } else {
                return `${this.selectedValues.length} selected`;
            }
        },
    },
    methods: {
        closeDropdown() {
            this.isOpen = false;
        },
        handleOptionToggle(optionId) {
            this.$emit('selection-change', optionId);
        },
        toggleDropdown() {
            this.isOpen = ! this.isOpen;
        },
    },
    mounted() {
        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (! this.$el.contains(e.target)) {
                this.closeDropdown();
            }
        });
    }
};
</script>

<style scoped>
.multi-select-dropdown {
    position: relative;
    flex: 1;
    min-width: 177px;
}

.multi-select-trigger {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    background-color: #666;
    color: white;
    font-size: 14px;
    line-height: 14px;
    border: 0;
    border-radius: 0;
    width: 100%;
    height: 40px;
    padding: 0 15px;
    text-align: left;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

.multi-select-trigger:focus {
    outline: none;
    border-color: #ff6b35;
    box-shadow: 0 0 0 2px rgba(255, 107, 53, 0.2);
}

.multi-select-trigger:hover {
    background-color: #777;
}

.multi-select-label {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.multi-select-arrow {
    transition: transform 0.2s ease;
    flex-shrink: 0;
}

.multi-select-arrow.rotated {
    transform: rotate(180deg);
}

.multi-select-dropdown-panel {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #333;
    border: 1px solid #555;
    border-top: none;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
}

.multi-select-options {
    padding: 8px 0;
}

.multi-select-option {
    display: flex;
    align-items: center;
    padding: 8px 15px;
    cursor: pointer;
    color: white;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: normal;
}

.multi-select-option:hover {
    background-color: #444;
}

.multi-select-checkbox {
    margin-right: 10px;
    accent-color: #ff6b35;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
}

.multi-select-checkbox:checked::after {
    color: #000;
}

.multi-select-option-text {
    flex: 1;
}

@media (max-width: 768px) {
    .multi-select-dropdown {
        width: 100%;
    }
}
</style>
